export const getQueryParams: () => URLSearchParams = () => {
  const queryString = window.location.search;
  return new URLSearchParams(queryString);
};
